import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ChartistModule } from 'ng-chartist';
import { ClickOutsideModule } from 'ng-click-outside';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { QuillModule } from 'ngx-quill';
import { RouterModule } from '@angular/router';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

import { AccountFunnelAutomationComponent } from './automation/account-funnel-automation.component';
import { AccountFunnelDashboardComponent } from './dashboard/account-funnel-dashboard.component';
import { AccountFunnelInboxesComponent } from './inboxes/account-funnel-inboxes.component';
import { AccountFunnelApplicationsComponent } from './applications/account-funnel-applications.component';
import { AccountFunnelLayoutComponent } from './layout/account-funnel-layout.component';
import { AccountFunnelMissionControlComponent } from './mission-control/account-funnel-mission-control.component';
import { AccountFunnelResourcesComponent } from './resources/account-funnel-resources.component';
import { AccountFunnelRouting } from './account-funnel.routing';
import { AccountFunnelSettingsComponent } from './settings/account-funnel-settings.component';
import { AccountFunnelSideMenuComponent } from './side-menu/account-funnel-side-menu.component';
import { AccountFunnelStepEmailComponent } from './steps/email/account-funnel-step-email.component';
import { AccountFunnelStepsComponent } from './steps/account-funnel-steps.component';
import { AccountFunnelStepInputComponent } from './steps/input/account-funnel-step-input.component';
import { AccountFunnelStepTaskComponent } from './steps/task/account-funnel-step-task.component';
import { ModalsModule } from '../../modals/modals.module';
import { SharedModule } from '../../shared/shared.module';
import { AccountFunnelStepSmsComponent } from './steps/sms/account-funnel-step-sms.component';
import { AccountFunnelStepCheckpointComponent } from './steps/checkpoint/account-funnel-step-checkpoint.component';
import { AccountFunnelStepCallComponent } from './steps/call/account-funnel-step-call.component';
import { ConditionsListComponent } from './steps/conditions-list/conditions-list.component';
import { ConditionOpenComponent } from './steps/condition-open/condition-open.component';
import { ConditionClickComponent } from './steps/condition-click/condition-click.component';
import { FunnelStepComponent } from './steps/funnel-step-stats/funnel-step-stats.component';
import { AccountFunnelStepInfoComponent } from './steps/info/account-funnel-step-info.component';
import { AccountFunnelStepWebhookComponent } from './steps/webhook/account-funnel-step-webhook.component';
import { AccountFunnelStepWaitComponent } from './steps/wait/account-funnel-step-wait.component';
import { AccountFunnelStepMultiComponent } from './steps/multi/account-funnel-step-multi.component';

@NgModule({
  declarations: [
    AccountFunnelAutomationComponent,
    AccountFunnelDashboardComponent,
    AccountFunnelInboxesComponent,
    AccountFunnelApplicationsComponent,
    AccountFunnelLayoutComponent,
    AccountFunnelMissionControlComponent,
    AccountFunnelResourcesComponent,
    AccountFunnelSettingsComponent,
    AccountFunnelSideMenuComponent,
    AccountFunnelStepEmailComponent,
    AccountFunnelStepsComponent,
    AccountFunnelStepInputComponent,
    AccountFunnelStepMultiComponent,
    AccountFunnelStepTaskComponent,
    AccountFunnelStepInfoComponent,
    AccountFunnelStepWaitComponent,
    AccountFunnelStepWebhookComponent,
    AccountFunnelStepSmsComponent,
    AccountFunnelStepCheckpointComponent,
    AccountFunnelStepCallComponent,
    ConditionsListComponent,
    ConditionOpenComponent,
    ConditionClickComponent,
    FunnelStepComponent,
  ],
  exports: [
    AccountFunnelAutomationComponent,
    AccountFunnelDashboardComponent,
    AccountFunnelInboxesComponent,
    AccountFunnelApplicationsComponent,
    AccountFunnelLayoutComponent,
    AccountFunnelMissionControlComponent,
    AccountFunnelResourcesComponent,
    AccountFunnelSettingsComponent,
    AccountFunnelSideMenuComponent,
    AccountFunnelStepEmailComponent,
    AccountFunnelStepsComponent,
    AccountFunnelStepInputComponent,
    AccountFunnelStepMultiComponent,
    AccountFunnelStepTaskComponent,
    AccountFunnelStepInfoComponent,
    AccountFunnelStepWaitComponent,
    AccountFunnelStepWebhookComponent,
    AccountFunnelStepSmsComponent,
    AccountFunnelStepCheckpointComponent,
    AccountFunnelStepCallComponent,
    ConditionsListComponent,
    ConditionOpenComponent,
    ConditionClickComponent,
    FunnelStepComponent,
  ],
  imports: [
    AccountFunnelRouting,
    BsDropdownModule.forRoot(),
    ChartistModule,
    ClickOutsideModule,
    CommonModule,
    FormsModule,
    ModalsModule,
    PaginationModule.forRoot(),
    ReactiveFormsModule,
    RouterModule,
    SharedModule,
    TooltipModule.forRoot(),
    QuillModule.forRoot(),
  ],
})
export class AccountFunnelModule {
  constructor() {
    console.log('>>> Bootstrap AccountFunnelModule');
  }
}
